import { getExtension } from "@shared/ui/attachmentIcon";

// Limited by what Amazon Textract (our OCR pipeline) actually accepts — PDF, JPEG, PNG, TIFF.
// DOC/DOCX skip OCR entirely (they already carry a text layer).
const SUPPORTED_EXTENSIONS = ["pdf", "doc", "docx", "jpg", "jpeg", "png", "tiff", "tif"];

export function isSupportedAttachment(fileName: string): boolean {
  return SUPPORTED_EXTENSIONS.includes(getExtension(fileName));
}
